import axiosInstance from "./axiosInstance";

export const fetchTaxRate = () => axiosInstance.get("/superadmin/master-data/tax-rate");

export const updateTaxRate = (data) => axiosInstance.put("/superadmin/master-data/tax-rate", data);

export const fetchTaxRateLogs = (page = 1, limit = 10) =>
  axiosInstance.get("/superadmin/master-data/tax-rate/logs", {
    params: { page, limit },
  });
